import { createImageVariantConfig } from '../../util/sdkLoader';
import { blogLoader } from '../../util/blogLoader';

const sharetribeSdk = require('sharetribe-flex-sdk');
const sdk = sharetribeSdk.createInstance({
  clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
});

export const getLatestBlogPosts = (count = 5) => {
  return blogLoader
    .get(`/posts?_sort=createdAt:DESC&_start=0&_limit=${count}`)
    .then(response => {
      return response.data;
    })
    .catch(e => {
      console.error('Error fetching blog posts:', e);
      return [];
    });
};

export const getRandomProducts = (count = 5) => {
  const aspectWidth = 1;
  const aspectHeight = 1;
  const variantPrefix = 'listing-card';
  const aspectRatio = aspectHeight / aspectWidth;

  return sdk.listings
    .query({
      pub_listingType: 'product-selling',
      minStock: 1,
      perPage: 50, // Fetch more to randomize from
      include: ['author', 'images'],
      'fields.listing': ['title', 'geolocation', 'price', 'publicData'],
      'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
      'fields.image': [
        'variants.scaled-small',
        'variants.scaled-medium',
        `variants.${variantPrefix}`,
        `variants.${variantPrefix}-2x`,
        'variants.default',
      ],
      ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      'limit.images': 1,
    })
    .then(res => {
      const listings = res.data.data;
      const images =
        res.data.included &&
        res.data.included.filter(i => i.type === 'image');

      if (listings && listings.length > 0) {
        listings.forEach(l => {
          const imageId = l.relationships.images.data[0]?.id.uuid;
          const luckyImage = images.find(i => i?.id.uuid === imageId);
          l.images = [luckyImage];
        });
      }

      // Shuffle and return random 5 products
      const shuffled = listings.sort(() => 0.5 - Math.random());
      return shuffled.slice(0, count);
    })
    .catch(e => {
      console.error('Error fetching products:', e);
      return [];
    });
};

